import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import Textarea from 'react-textarea-autosize';
import PropTypes from 'prop-types';
import './text-input.scss';
function TextInput({ hasError, label, value, onChange, maxLength, name, placeholder }) {
    return (_jsx("div", { className: hasError ? 'text-input--error' : 'text-input', children: _jsxs("label", { htmlFor: name, children: [_jsx("span", { className: "label", children: hasError ? `* ${label}` : label }), _jsx(Textarea, { name: name, value: value, className: "textarea", onChange: onChange, maxLength: maxLength, placeholder: placeholder })] }) }));
}
TextInput.propTypes = {
    hasError: PropTypes.bool,
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    maxLength: PropTypes.string,
    name: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
};
TextInput.defaultProps = {
    maxLength: '',
    placeholder: '',
    hasError: false,
};
export default TextInput;
